export default {
  '405': '密码不正确',
  '406': '此用户不存在',
  '407': '参数不匹配',
  '408': '新密码和确认密码不匹配',
  '409': '密码不正确',
  '411': '用户已存在',
  '412': '密码长度不是6-16',
  '413': '手机号已注册',
  '414': '结束时间不能小于开始时间',
  '415': '请选择开始日期',
  '416': '请选择结束日期',
  '417': '请选择交易账户',
  '5002': '获取余额错误',
  '6002': '发送邮件异常',
  '5003': '账户异常，请联系管理员',
  '5004': '获取用户邮箱模板失败，请联系客服',
  '51001': '账户信息不存在',
  '51002': '交易账号不存在',
  '51003': '交易账号类型不存在',
  '51004': '交易账号类型错误',
  '500': '服务器异常，请联系客服',
  '11000': '获取余额失败，请联系客服'

}
